'use strict';
module.exports = require('./InputNumber.vue');